import React, { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router';
import Pagination from '../../components/Pagination';
import axios from 'axios';
import { API_URL } from '../../../config/constants';
import "react-datepicker/dist/react-datepicker.css";
import filledArrowIconImg from '../../../images/filledArrowIcon.png';
import resetIconImg from '../../../images/resetIcon.png';
import ChkDelModal from '../../components/ChkDelModal';
import { CustomDatePickerStart, CustomDatePickerEnd } from '../../components/CustomDatePicker';
import moment from 'moment';
import Select from 'react-select';
import SumDataThead from './components/SumDataThead';
import SumDataTbodyRow from './components/SumDataTbodyRow';
import csvSaveIcon from '../../../images/csvSave.png';
import { CSVLink } from 'react-csv';
import refreshIcon from '../../../images/refresh.png';
import CSVPopup from './components/CSVPopup';
import SavingPopup from './components/SavingPopup';
import Loading from '../../components/Loading';
import Nodatafiltered from '../../components/Nodatafiltered';

function ShowData(props) {
    const { sumDsData, modelTypeArr, modelNameArr, modelNoArr, modelData, chkAll, setChkAll, chkedData, setChkedData, dataArr, setDataArr, startedAt, rowCount, userIsNormal } = useOutletContext();
    const companyInitial = 'K';
    const navigate = useNavigate();

    const limit = 20;
    const [page, setPage] = useState(1);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [selSumDs, setSelSumDs] = useState(-1);
    const [filter_time, setFilter_time] = useState({
        fixedStartDate: startedAt ? moment(startedAt).toDate() : moment().toDate(),
        fixedEndDate: moment(),
    });
    const [filter_decision, setFilter_decision] = useState("all");
    const [filter_modelType, setFilter_modelType] = useState("all");
    const [filter_modelName, setFilter_modelName] = useState("all");
    const [filter_modelNo, setFilter_modelNo] = useState("all");
    const [filter_comment, setFilter_comment] = useState("all");
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [selectPeriod, setSelectPeriod] = useState("currentWorks");
    const [sortingAsc, setSortingAsc] = useState({
        time: false,
        count: false,
        decision: false,
        modelType: false,
        modelName: false,
        modelNo: false,
    });
    const [sortingArr, setSortingArr] = useState([]);
    const [modelTypes, setModelTypes] = useState(["all"]);
    const [modelNames, setModelNames] = useState(["all"]);
    const [modelNos, setModelNos] = useState(["all"]);
    const [delModalOpen, setDelModalOpen] = useState(false);
    const [curPageData, setCurPageData] = useState([]);
    const [openCSVPopup, setOpenCSVPopup] = useState(false);
    const [openSavingPopup, setOpenSavingPopup] = useState(false);
    const [csvPopupType, setCsvPopupType] = useState('none'); // 'none' | 'noSelection' | 'allSelected'
    const [isDownloadCompleted, setIsDownloadCompleted] = useState(false);
    const [filterLoading, setFilterLoading] = useState(false);

    function getDecision(index, data, aton) {
        return data[`sDecision_${index}`] ?? '-';
    }

    function onFiltering(condition, value) {
        switch (condition) {
            case 'decision':
                setFilter_decision(value);
                break;
            case 'modelType':
                setFilter_modelType(value);
                break;
            case 'modelName':
                setFilter_modelName(value);
                break;
            case 'modelNo':
                setFilter_modelNo(value);
                break;
            case 'comment':
                setFilter_comment(value);
            default:
                break;
        }
    };
    function onSorting(e, condition, isAsc) {
        e.preventDefault();
        // var newArray = [...dataArr];
        setSortingAsc({ ...sortingAsc, [condition]: isAsc });
        const curArr = [...sortingArr];
        const filteredArr = curArr.filter(el => el[0] !== condition);
        setSortingArr([[condition, isAsc ? "ASC" : "DESC"], ...filteredArr]);
    }

    const onRefresh = (e) => {
        e.preventDefault();
        if (selectPeriod === 'currentWorks') {
            setEndDate(moment().toDate());
            setFilter_time({ ...filter_time, fixedEndDate: moment(), });
        } else {
            getFilteredData();
        }
    }

    async function getFilteredData() {
        setFilterLoading(true);
        try {
          const res = await axios.post(`${API_URL}/monitoring-manage/lookupSumDataByCond`, {
            organization: '세동산업',
            sumDsId: selSumDs,
            filter_time, filter_decision, filter_modelType, filter_modelName, filter_modelNo, filter_comment,
            sortingArr,
            pageNo: page
          });
      
          const { sumDatas, rowCount } = res.data;
          setDataArr([...sumDatas]);
          setTotalRowCount(rowCount);
        } finally {
          setFilterLoading(false);
        }
      }

    useEffect(() => {
        if (selSumDs !== -1) {
            getFilteredData();
            setPage(1);
            setChkAll(false)
            setChkedData([])
        }
    }, [sumDsData, selSumDs, filter_time, filter_decision, filter_modelType, filter_modelName, filter_modelNo, filter_comment, sortingArr]);
    useEffect(() => {
        if (selSumDs !== -1) {
            getFilteredData();
        }
    }, [page])
    useEffect(() => {
        const sumDsId = sumDsData ? sumDsData.sumDsId : -1;
        const sortingOpt = {};

        setSelSumDs(sumDsId);
        setModelTypes(["all", ...modelTypeArr]);
        setModelNames(["all", ...modelNameArr]);
        setModelNos(["all", ...modelNoArr.map(item => item.modelNo)])
        setFilter_modelType("all");
        setFilter_modelName("all");
        setFilter_modelNo("all");
        setSortingAsc({
            ...sortingAsc,
            ...sortingOpt
        })
        // setRowCount(rowCount);
    }, [sumDsData])
    
    //임시: filterLoading 상태 확인용
    // useEffect(() => {
    //     console.log('filterLoading:', filterLoading);
    //   }, [filterLoading]);

    useEffect(() => {
        setChkedData([]);
    }, [page, setChkedData, sumDsData])

    useEffect(() => {
        switch (selectPeriod) {
            case 'input':
                // 사용자가 직접 입력하는 모드: start/end 유지
                break;
            case 'currentWorks':
                setStartDate(startedAt ? moment(startedAt).toDate() : moment().toDate());
                setEndDate(moment().toDate());
                break;
            case '1h':
                setStartDate(moment().subtract(1, 'hours').toDate());
                setEndDate(moment().toDate());
                break;
            case '24h':
                setStartDate(moment().subtract(1, 'days').toDate());
                setEndDate(moment().toDate());
                break;
            default:
                setStartDate(moment().toDate());
                setEndDate(moment().toDate());
                break;
        }
    }, [selectPeriod])
    const periodOpt = [
        { label: '시간직접입력', value: 'input' },
        { label: '현재공정', value: 'currentWorks' },
        { label: '최근 1시간', value: '1h' },
        { label: '최근 24시간', value: '24h' },
    ];
    function makeCsvData(datum) {
        // function onSaveAsCSV(e) {
        // e.preventDefault();
        const { dataClass, indexName, valView, variView, okNgView, applyToOkNg } = sumDsData;
        const labelArrA = ["시간", "카운트", "차종", "품명", "품번", "판정",];
        const labelArrB = [];
        const labelArrC = ["NG 요인", "코멘트"]

        for (let i = 0; i < dataClass.length; i++) {
            const className = dataClass[i]
            const valViewArr = valView[i];
            const variViewArr = variView[i];
            const hasVal = valViewArr.filter(e => e === true).length > 0
            if (hasVal) {
                for (let j = 0; j < indexName[i].length; j++) {
                    if (valViewArr[j]) {
                        const iName = indexName[i][j]
                        labelArrB.push(`${className} - ${iName}`)
                        if (variViewArr[j]) labelArrB.push(`${className} - ${iName} 편차`)
                    }
                }
                if (okNgView[i]) labelArrB.push(`${className} 판정`)
            }
        }

        const labelArr = [...labelArrA, ...labelArrB, ...labelArrC]
        const valueArr = datum.map(item => {
            const valueArr1 = [moment(item.time).tz("Asia/Seoul").format('yyyy-MM-DD H:mm:ss'), item.count, item.model.modelType, item.model.modelName, item.model.modelNo, item.decision];
            const valueArr2 = [];
            const valueArr3 = [item.ngFactor, item.comment];
            for (let i = 0; i < dataClass.length; i++) {
                const className = dataClass[i]
                const valViewArr = valView[i];
                const variViewArr = variView[i];
                const hasVal = valViewArr.filter(e => e === true).length > 0
                const stdValOuter = item?.model ? JSON.parse(item.model.stdVal)[i] : [];
                if (hasVal) {
                    for (let j = 0; j < indexName[i].length; j++) {
                        if (valViewArr[j]) {
                            valueArr2.push(item[`data_${i}_${j}`]);
                            if (variViewArr[j]) {
                                const stdVal = stdValOuter[j];
                                const vari = item[`data_${i}_${j}`] ? Math.round(Math.abs((item[`data_${i}_${j}`] - stdVal[0]) / stdVal[0]) * 1000) / 10 : 0
                                valueArr2.push(`${vari}%`)
                            }
                        }
                    }
                    if (okNgView[i]) valueArr2.push(getDecision(i, item, applyToOkNg))
                }
            }
            return [...valueArr1, ...valueArr2, ...valueArr3]
        });
        console.log(valueArr)
        const mergedArr = [labelArr, ...valueArr];
        return mergedArr;
    }

    function getFileName() {
        const fileName = `${companyInitial}S${moment().format("YYMMDD_HHmmss")}`;
        return fileName;
    }

    function handleDownloadCsv(e) {
        e.preventDefault();
        // 아무것도 체크 안한 경우: 간단한 예/아니오 팝업
        if (chkedData.length === 0) {
            setCsvPopupType('noSelection');
            setOpenCSVPopup(true);
            return;
        }
        // 전체 체크된 경우: 선택 기간 전체/현재 페이지 선택 팝업
        if (chkAll) {
            setCsvPopupType('allSelected');
            setOpenCSVPopup(true);
            return;
        }

        // 일부 또는 페이지 전부 체크한 경우: 바로 저장
        const csvData = makeCsvData(curPageData.filter(el => chkedData.includes(el.dataId.toString())));

        // if (!csvData || chkedData.length === 0) {
        //     alert("저장할 데이터가 없습니다.");
        //     return;
        // }

        const csvRows = csvData.map(row => row.join(',')).join('\n');
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvRows], { type: 'text/csv;charset=utf-8;' });

        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.href = url;

        const filename = `${getFileName()}.csv`;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    async function savePeriodData() {
        try {
            setOpenCSVPopup(false);
            setCsvPopupType('none');
            setOpenSavingPopup(true);
            setIsDownloadCompleted(false);

            // 대용량 데이터 처리를 위한 타임아웃 설정 (10분)
            const response = await axios.post(`${API_URL}/monitoring-manage/lookupSumDataByCond`, {
                organization: '세동산업', sumDsId: selSumDs,
                filter_time, filter_decision, filter_modelType, filter_modelName, filter_modelNo, filter_comment, sortingArr, pageNo: -1
            }, {
                timeout: 600000 // 10분
            });

            if (!response.data || !response.data.sumDatas) {
                throw new Error('데이터를 받아오지 못했습니다.');
            }

            const { sumDatas } = response.data;
            
            // 데이터가 너무 많은 경우 스트리밍 방식으로 전환
            if (sumDatas.length > 10000) {
                await downloadViaStreaming();
                return;
            }

            const csvData = makeCsvData(sumDatas);

            const csvRows = csvData.map(row => row.join(',')).join('\n');
            const BOM = '\uFEFF';
            const blob = new Blob([BOM + csvRows], { type: 'text/csv;charset=utf-8;' });

            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;

            const filename = `${getFileName()}.csv`;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            // 다운로드 완료 상태로 변경
            setIsDownloadCompleted(true);

        } catch (err) { 
            console.error(err);
            setOpenSavingPopup(false);
            setIsDownloadCompleted(false);
            
            // 에러 메시지 표시
            let errorMessage = '데이터 다운로드 중 오류가 발생했습니다.';
            if (err.code === 'ECONNABORTED') {
                errorMessage = '요청 시간이 초과되었습니다. 데이터가 너무 많을 수 있습니다. 잠시 후 다시 시도해주세요.';
            } else if (err.response) {
                errorMessage = `서버 오류: ${err.response.status} ${err.response.statusText}`;
            } else if (err.message) {
                errorMessage = err.message;
            }
            alert(errorMessage);
        }
    }

    // 스트리밍 방식으로 다운로드
    async function downloadViaStreaming() {
        try {
            const response = await axios.post(
                `${API_URL}/monitoring-manage/downloadSumDataAsCSV`,
                {
                    organization: '세동산업',
                    sumDsId: selSumDs,
                    filter_time,
                    filter_decision,
                    filter_modelType,
                    filter_modelName,
                    filter_modelNo,
                    filter_comment,
                    sortingArr
                },
                {
                    responseType: 'blob',
                    timeout: 600000 // 10분
                }
            );

            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const filename = `${getFileName()}.csv`;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            setIsDownloadCompleted(true);
        } catch (err) {
            console.error(err);
            setOpenSavingPopup(false);
            setIsDownloadCompleted(false);
            let errorMessage = '스트리밍 다운로드 중 오류가 발생했습니다.';
            if (err.code === 'ECONNABORTED') {
                errorMessage = '요청 시간이 초과되었습니다. 잠시 후 다시 시도해주세요.';
            } else if (err.response) {
                errorMessage = `서버 오류: ${err.response.status}`;
            }
            alert(errorMessage);
        }
    }
    async function savePageData() {
        try {
            setOpenCSVPopup(false);
            setCsvPopupType('none');
            setOpenSavingPopup(true);
            setIsDownloadCompleted(false);

            // 화면을 렌더링 할 시간을 주기 위해 잠시 대기
            await new Promise(resolve => setTimeout(resolve, 50));

            const csvData = makeCsvData(curPageData.filter(el => chkedData.includes(el.dataId.toString())));

            const csvRows = csvData.map(row => row.join(',')).join('\n');
            const BOM = '\uFEFF';
            const blob = new Blob([BOM + csvRows], { type: 'text/csv;charset=utf-8;' });

            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;

            const filename = `${getFileName()}.csv`;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            // 다운로드 완료 상태로 변경
            setIsDownloadCompleted(true);

        } catch (err) { 
            console.error(err);
            setOpenSavingPopup(false);
            setIsDownloadCompleted(false);
        }
    }

    useEffect(() => {
        setTotalRowCount(rowCount);
    }, []);

    useEffect(() => {
        // console.log('커페이지데이터 교체')
        setCurPageData([...dataArr]);
    }, [dataArr]);
    if (!sumDsData) return null;
    return (
        <React.Fragment>
            <div className='dataMainArea'>
                <p className='path'>데이터 관리<span className='below'>{'>'}</span>공정 요약</p>
                <h2 className='pageTitle'>공정 요약 - {sumDsData.name}</h2>
                <button className='refreshBtn' onClick={onRefresh}>
                    <img src={refreshIcon} alt='새로고침' />
                </button>
                <div className='pageContent'>

                    <div className='btnsArea'>
                        <div className='periodBtnsArea'>
                            <form onSubmit={e => {
                                e.preventDefault();
                                setFilter_time({
                                    fixedStartDate: startDate,
                                    fixedEndDate: endDate,
                                });
                            }}>
                                <span className='datePickerLabel'>시간</span>
                                <div className='datePickerArea'>
                                    <div className='startDateArea'>
                                        <CustomDatePickerStart startDate={startDate} setStartDate={setStartDate} endDate={endDate} changeDropdown={() => setSelectPeriod('input')} />
                                    </div>
                                    <span>-</span>
                                    <div className='endDateArea'>
                                        <CustomDatePickerEnd startDate={startDate} endDate={endDate} setEndDate={setEndDate} changeDropdown={() => setSelectPeriod('input')} />
                                    </div>
                                </div>
                                <Select
                                    options={periodOpt}
                                    value={periodOpt.find(el => el.value === selectPeriod)}
                                    onChange={sel => setSelectPeriod(sel.value)}
                                    isSearchable={false}
                                    classNames={{
                                        control: (state) => 'control',
                                        container: (state) => 'selectBox',
                                        dropdownIndicator: (state) => 'arrow',
                                        menu: (state) => 'options',
                                        menuList: (state) => 'optionsList',
                                        option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                                        singleValue: (state) => 'singleVal',
                                        valueContainer: (state) => 'valueContainer',
                                    }}
                                    components={{
                                        DropdownIndicator: (state) => <span className={state.isFocused ? 'arrowIcon focused' : 'arrowIcon'} ><img src={filledArrowIconImg} alt={'드롭다운'} /></span>,
                                        IndicatorSeparator: (state) => null,
                                    }}
                                />
                                <input className='submitPeriod' type='submit' value={'적용'} />
                                <button className='resetPeriod' onClick={e => {
                                    e.preventDefault();
                                    setSelectPeriod('currentWorks');
                                    setFilter_time({
                                        fixedStartDate: startedAt ? moment(startedAt).toDate() : moment().toDate(),
                                        fixedEndDate: endDate,
                                    });
                                    setStartDate(startedAt ? moment(startedAt).toDate() : moment().toDate());
                                    setEndDate(moment().toDate());
                                }}><span>초기화</span><img src={resetIconImg} alt={"초기화"} /></button>
                            </form>
                        </div>
                        <div className='btnsArea'>
                            <div className={'viewModeBtnsArea'}>

                                <button className='saveCSVBtn' onClick={handleDownloadCsv}> <img src={csvSaveIcon} alt='csv 저장' />
                                    <span>CSV 저장</span></button>
                                <button className='createData' onClick={(e) => {
                                    e.preventDefault();
                                    navigate(`/home/data/sumData/create?sumDsId=${selSumDs}`);
                                }}
                                    disabled={userIsNormal}
                                >추가</button>
                                <button className='deleteData' onClick={e => {
                                    e.preventDefault();
                                    setDelModalOpen(true);
                                }} disabled={chkedData.length === 0 || userIsNormal}>삭제</button>
                            </div>
                        </div>
                    </div>
                    <div className="tblArea">
                      <div className="tblScroll">
                        <table>
                          <SumDataThead
                            sumDs={sumDsData}
                            modelTypes={modelTypes}
                            modelNames={modelNames}
                            modelNos={modelNos}
                            modelData={modelData}
                            chkAll={chkAll}
                            setChkAll={setChkAll}
                            idsInThisPage={dataArr.map(item => item.dataId.toString())}
                            setChkedData={setChkedData}
                            onSorting={onSorting}
                            sortingAsc={sortingAsc}
                            onFiltering={onFiltering}
                            filter_modelType={filter_modelType}
                            filter_modelName={filter_modelName}
                            setFilter_modelName={setFilter_modelName}
                            filter_modelNo={filter_modelNo}
                            setFilter_modelNo={setFilter_modelNo}
                            setModelNames={setModelNames}
                            setModelNos={setModelNos}
                            setFilterLoading={setFilterLoading}
                          />

                          <tbody>
                            {filterLoading ? (
                              <tr>
                                <td colSpan={1000} style = {{border : "none"}}>
                                  <Loading />
                                </td>
                              </tr>
                            ) : dataArr.length === 0 ? (
                              <tr>
                                <td colSpan={1000}>
                                  <Nodatafiltered />
                                </td>
                              </tr>
                            ) : (
                              Array.from({ length: 20 }, (_, index) => {
                                const item = curPageData[index];
                                return (
                                  <SumDataTbodyRow
                                    key={index}
                                    index={index}
                                    item={item}
                                    chkedData={chkedData}
                                    setChkedData={setChkedData}
                                    sumDs={sumDsData}
                                    isVacant={!item}
                                  />
                                );
                              })
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <Pagination
                        total={totalRowCount}
                        limit={limit}
                        page={page}
                        setPage={setPage}
                    />
                </div>
            </div>
            <ChkDelModal
                isOpen={delModalOpen}
                onRequestClose={e => {
                    e.preventDefault();
                    setDelModalOpen(false);
                }}
                onSubmit={async (e) => {
                    e.preventDefault();
                    const chkedDataArr = [...chkedData];
                    await axios.post(`${API_URL}/monitoring-manage/deleteSumData`, { id: chkedDataArr.map(e => parseInt(e)), sumDsId: selSumDs }).then(() => {
                        window.location.href = '/home/data/sumData';
                    }).catch(err => console.error(err));
                }}
            />
            <CSVPopup
                isOpen={openCSVPopup}
                onRequestClose={e => { 
                    e.preventDefault(); 
                    setOpenCSVPopup(false);
                    setCsvPopupType('none');
                }}
                savePeriodData={savePeriodData}
                savePageData={savePageData}
                popupType={csvPopupType}
            />
            <SavingPopup
                isOpen={openSavingPopup}
                isCompleted={isDownloadCompleted}
                onClose={() => {
                    setOpenSavingPopup(false);
                    setIsDownloadCompleted(false);
                }}
            />
        </React.Fragment>
    );
}

export default ShowData;
